import i18next from 'i18next';
import { FeatureFlag } from '@cbo/shared-library';

import routes from '../../../constants/routes';
import { NavItem } from '.';
import { useFeatureFlags } from '../../../utils/hooks/useFeatureFlag';

export default function useCountingAndLocationRoutes(): NavItem[] {
  const [asmCore, mobileInventoryEnabled] = useFeatureFlags(FeatureFlag.asmCore, FeatureFlag.mobileInventory);
  const countingAndLocationsRoutes: NavItem[] = [];

  if (asmCore && mobileInventoryEnabled) {
    countingAndLocationsRoutes.push({
      title: i18next.t('navItems.inventoryLists'),
      href: routes.INVENTORY_LISTS,
      testid: 'inventory-lists',
    });

    countingAndLocationsRoutes.push({
      title: i18next.t('navItems.locations'),
      href: routes.LOCATIONS,
      testid: 'locations-summary',
    });
  }

  return countingAndLocationsRoutes;
}
